module.exports = __webpack_public_path__ + "bc6b020eb5504481dfb47a6c11a2ab9a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-SemiBold.svg
 ** module id = 916
 ** module chunks = 9
 **/